import type { Dispatch } from "react";
import type { PageEditorFragment } from "../client/generated";
import type { EditorAction, EditorState } from "./reducers";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Page } from "./Page";
import { PageMinimap } from "./PageMinimap";
import { useNavigate } from "react-router";
import { routingPaths } from "../navigation/constants";
import { PageOverlay } from "./PageOverlay";

type Props = {
  fragment: PageEditorFragment;
  state: EditorState;
  dispatch: Dispatch<EditorAction>;
};

export function PageEditor({ fragment, state, dispatch }: Props) {
  const navigate = useNavigate();

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "ArrowLeft") {
      event.stopPropagation();
      if (!fragment.previousPage) return;
      navigate(
        routingPaths.documentPage(
          fragment.document.id,
          fragment.previousPage.id,
        ),
      );
    } else if (event.key === "ArrowRight") {
      event.stopPropagation();
      if (!fragment.nextPage) return;
      navigate(
        routingPaths.documentPage(fragment.document.id, fragment.nextPage.id),
      );
    }
  };

  return (
    <div className="h-full flex flex-col" onKeyDown={onKeyDown} tabIndex={0}>
      <TransformWrapper
        centerOnInit
        minScale={0.25}
        maxScale={4}
        doubleClick={{ disabled: true }}
        panning={{
          allowLeftClickPan: false,
          allowRightClickPan: false,
          allowMiddleClickPan: true,
          velocityDisabled: true,
        }}
      >
        <PageMinimap key={fragment.id} fragment={fragment} />
        <TransformComponent wrapperClass="w-full! h-full! bg-gray-100 dark:bg-gray-900">
          <Page fragment={fragment} />
          <PageOverlay
            key={fragment.id}
            state={state}
            fragment={fragment}
            dispatch={dispatch}
          />
        </TransformComponent>
      </TransformWrapper>
    </div>
  );
}
